import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Tab: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.6591 9.24074H2.34091C2.1527 9.24074 2 9.07484 2 8.87037C2 8.6659 2.1527 8.5 2.34091 8.5H21.6591C21.8473 8.5 22 8.6659 22 8.87037C22 9.07484 21.8473 9.24074 21.6591 9.24074Z'
        fill='url(#paint0_linear_12280_28705)'
        stroke='url(#paint1_linear_12280_28705)'
        strokeWidth='0.7'
      />
      <path
        d='M20.9179 21.105H3.0822C2.48473 21.105 2 20.5764 2 19.9292V4.6601C2 4.01099 2.4865 3.48438 3.0822 3.48438H20.9161C21.5135 3.48438 21.9983 4.01292 21.9983 4.6601V19.9292C21.9983 20.5784 21.5118 21.105 20.9161 21.105H20.9179ZM3.0822 4.2262C2.86203 4.2262 2.68182 4.42103 2.68182 4.66119V19.9303C2.68182 20.1695 2.86115 20.3653 3.0822 20.3653H20.9161C21.1362 20.3653 21.3165 20.1705 21.3165 19.9303L21.3156 4.6602C21.3156 4.421 21.1362 4.22521 20.9152 4.22521L3.0822 4.2262Z'
        fill='url(#paint2_linear_12280_28705)'
        stroke='url(#paint3_linear_12280_28705)'
        strokeWidth='0.7'
      />
      <path
        d='M8.66145 16.5723C8.57533 16.5723 8.48656 16.5356 8.42086 16.4633L6.35054 14.2141C6.21649 14.0684 6.21649 13.834 6.35054 13.6903L8.35959 11.5077C8.49364 11.362 8.70938 11.362 8.84165 11.5077C8.97571 11.6533 8.97571 11.8877 8.84165 12.0314L7.0732 13.9527L8.90293 15.9405C9.03698 16.0862 9.03698 16.3206 8.90293 16.4643C8.83723 16.5356 8.74845 16.5733 8.66234 16.5733L8.66145 16.5723Z'
        fill='url(#paint4_linear_12280_28705)'
        stroke='url(#paint5_linear_12280_28705)'
        strokeWidth='0.7'
      />
      <path
        d='M15.5052 16.5733C15.4191 16.5733 15.3303 16.5366 15.2646 16.4643C15.1305 16.3186 15.1305 16.0842 15.2646 15.9405L17.0943 13.9527L15.3259 12.0314C15.1918 11.8858 15.1918 11.6514 15.3259 11.5077C15.4599 11.362 15.6757 11.362 15.8079 11.5077L17.817 13.6903C17.8809 13.7598 17.9173 13.8533 17.9173 13.9517C17.9173 14.0501 17.8809 14.1446 17.817 14.2131L15.7467 16.4623C15.681 16.5337 15.5922 16.5713 15.5061 16.5713L15.5052 16.5733Z'
        fill='url(#paint6_linear_12280_28705)'
        stroke='url(#paint7_linear_12280_28705)'
        strokeWidth='0.7'
      />
      <path
        d='M10.3474 17.4927C10.2906 17.4927 10.2311 17.4782 10.1796 17.4435C10.0163 17.3422 9.95943 17.1156 10.0527 16.9371L13.3552 10.6554C13.4484 10.4779 13.657 10.4162 13.8212 10.5175C13.9846 10.6187 14.0414 10.8454 13.9482 11.0238L10.6457 17.3056C10.5818 17.4242 10.4681 17.4936 10.3501 17.4936L10.3474 17.4927Z'
        fill='url(#paint8_linear_12280_28705)'
        stroke='url(#paint9_linear_12280_28705)'
        strokeWidth='0.7'
      />
      <circle
        cx='4.5'
        cy='6.44922'
        r='0.65'
        fill='url(#paint10_linear_12280_28705)'
        stroke='url(#paint11_linear_12280_28705)'
        strokeWidth='0.3'
      />
      <circle
        cx='6.5'
        cy='6.44922'
        r='0.65'
        fill='url(#paint12_linear_12280_28705)'
        stroke='url(#paint13_linear_12280_28705)'
        strokeWidth='0.3'
      />
      <circle
        cx='8.5'
        cy='6.44922'
        r='0.65'
        fill='url(#paint14_linear_12280_28705)'
        stroke='url(#paint15_linear_12280_28705)'
        strokeWidth='0.3'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_28705'
          x1='6.14154'
          y1='8.55051'
          x2='6.15715'
          y2='9.39521'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28705'
          x1='6.14154'
          y1='8.55051'
          x2='6.15715'
          y2='9.39521'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28705'
          x1='6.14118'
          y1='4.6859'
          x2='13.5464'
          y2='21.5309'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28705'
          x1='6.14118'
          y1='4.6859'
          x2='13.5464'
          y2='21.5309'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_28705'
          x1='6.82018'
          y1='11.7513'
          x2='9.76562'
          y2='14.8925'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_28705'
          x1='6.82018'
          y1='11.7513'
          x2='9.76562'
          y2='14.8925'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_28705'
          x1='15.7342'
          y1='11.7513'
          x2='18.6797'
          y2='14.8923'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_28705'
          x1='15.7342'
          y1='11.7513'
          x2='18.6797'
          y2='14.8923'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_28705'
          x1='10.8331'
          y1='10.9478'
          x2='14.807'
          y2='15.4663'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_28705'
          x1='10.8331'
          y1='10.9478'
          x2='14.807'
          y2='15.4663'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_28705'
          x1='4.20708'
          y1='6.01741'
          x2='4.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_28705'
          x1='4.20708'
          y1='6.01741'
          x2='4.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_28705'
          x1='6.20708'
          y1='6.01741'
          x2='6.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_28705'
          x1='6.20708'
          y1='6.01741'
          x2='6.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint14_linear_12280_28705'
          x1='8.20708'
          y1='6.01741'
          x2='8.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint15_linear_12280_28705'
          x1='8.20708'
          y1='6.01741'
          x2='8.66278'
          y2='6.93077'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Tab;
